export default "__VITE_ASSET__pYDJfchI__"